import { AndromedaMenuItem } from '@ansys-internal/awf-angular/contributions';
import { Icons } from '@ansys-internal/awc-angular/icons';
import { DialogService } from '@ansys-internal/awf-angular/shared';
import { AboutComponent } from '../../../components/dialogs/about/about.component';
import { PopoutService } from '@ansys-internal/awc-angular/popout';
import { AWFMenuItem } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../contributions.enum';

@AWFMenuItem({
  id: ContributionsEnum.USER_PROFILE_MENU_ABOUT_MENU_ITEM,
  priority: 50,
})
export class AboutMenu implements AndromedaMenuItem {
  id = ContributionsEnum.USER_PROFILE_MENU_ABOUT_MENU_ITEM;
  type = ContributionsEnum.USER_PROFILE_MENU_ABOUT_MENU_ITEM;
  prefixIcon = { icon: Icons.INFO };
  text = 'About';

  constructor(
    private dialog: DialogService,
    private popoutService: PopoutService
  ) {}

  execute(): Promise<unknown> {
    return new Promise<void>((resolve) => {
      this.dialog.open(AboutComponent, { title: 'About' });
      this.popoutService.closeAll();
      resolve();
    });
  }
}
